import React from 'react';
import {
  Form, FormGroup, Label,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField, CustomFormInput } from '../../../../../utils/FormFields';
import { parseDate } from '../../../../../utils';

function ArchivesTab({ person, changedPerson, showChanges , fetchFile}) {
  const editArchive = changedPerson.Archives[0];
  let isLifeLong = editArchive.PersonArchivesHasExpirationDate;
  let compareArchive;
  person.Archives.map((a) => {
    if (parseInt(a.PersonArchiveId, 10)
      === parseInt(editArchive.PersonArchiveId, 10)) {
      compareArchive = a;
    }
    return {};
  });
  let color = 'black';
  if (showChanges && editArchive.PersonArchiveId > 0) {
    color = 'red';
  } else if (showChanges && parseInt(editArchive.PersonArchiveId, 10) === 0) {
    color = 'green';
  }

  const getFile = (file) => {
    const body = {
      fileId: file.PersonArchivesTemporalFileId
    }
    fetchFile(body, (response) => {
      var a = document.createElement('A');
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }

  return (
    <Form>
      <Label style={{
        fontWeight: 500, fontSize: '20px', display: 'block', color,
      }}
      >
        {showChanges ? (
          <React.Fragment>
            {editArchive.PersonArchiveId > 0
              ? 'Remove Archive'
              : 'New Archive'}
          </React.Fragment>
        ) : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {parseInt(editArchive.PersonArchiveId, 10) === 0
              && <FormToShow archive={editArchive} compareArchive={compareArchive} getFile={getFile} />}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareArchive && <FormToShow archive={compareArchive} getFile={getFile}/>}
          </FormGroup>
        )}
    </Form>
  );
}

ArchivesTab.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
  showChanges: PropTypes.bool.isRequired,
};

ArchivesTab.defaultProps = {
  changedPerson: undefined,
};

const FormToShow = ({ archive, getFile }) => (
  <React.Fragment>
    <CustomFormInput label="File">
      {archive.PersonArchivesTemporalFileId > 0 ? 
        <a onClick= {() => getFile(archive)} style = {{cursor:'pointer'}}>
          {`${archive.PersonArchivesName}.${archive.PersonArchivesExtension}`}
        </a> 
      : /* Este es el caso para las alertas que tienen los blobs en el objeto item */
        <a href={`data:application/octet-stream;base64,${archive.PersonArchivesBlob}`} download={`${archive.PersonArchivesName}.${archive.PersonArchivesExtension}`}>
          {`${archive.PersonArchivesName}.${archive.PersonArchivesExtension}`}
        </a>
      }
      
    </CustomFormInput>
    <FormField
      name="PersonArchivesType"
      value={archive.PersonArchivesTypeDescription}
      label="Type"
    />
    <FormField
      name="PersonArchivesSubType"
      value={archive.PersonArchivesSubTypeDescription}
      label="Sub Type"
    />
    <FormField
      name="PersonArchivesEnabled"
      value={!archive.PersonArchivesEnabled ? 'Yes' : 'No'}
      label="Enabled?: "
    />
    {(archive.PersonArchivesHasExpirationDate == true)
      ? (
        <FormField
          name="PersonArchivesExpirationDate"
          value={parseDate(archive.PersonArchivesExpirationDate)}
          label="Expiration Date: "
          type="date"
        />
      ) : (
        <FormField
          name="PersonArchivesEnabled"
          value={!archive.PersonArchivesHasExpirationDate ? 'Yes' : 'No'}
          label="Lifelong?: "
        />
      )}
  </React.Fragment>
);

FormToShow.propTypes = {
  archive: PropTypes.object.isRequired,
};

export default (ArchivesTab);
